import React, { Component } from 'react';
import { Progress, Card, Col } from 'antd';
import { Link } from 'react-router-dom';
import './MachineStatusBoxView.css';
import constants from '../../constants';

class MachineStatusBoxView extends Component {
    render() {
        let colorChange = 'white';
        const colorBitacora = '#f1c40f';
        const colorTimer = '#e67e22';
        const colorTicket = '#2ecc71';
        if (this.props.status <= 100) {
            // colorChange = '#f1c40f';
            colorChange = colorTimer;
        }
        if (this.props.status > 50 && this.props.status <= 80) {
            colorChange = colorTicket;
        }
        if (this.props.status > 80 && this.props.status <= 100) {
            colorChange = colorBitacora;
        }

        const cont = (
            <Col xs={24} sm={12} md={8}>
                <Card.Grid className="single-card" style={{ background: colorChange }}>
                    <h3>
                        {this.props.name}
                    </h3>
                    <Progress type="circle" percent={this.props.status} />
                </Card.Grid>
            </Col>
        );
        const { type } = this.props.extraUser;
        if (type === constants.SADMIN_ROLE || type === constants.SUPV_ROLE
                || type === constants.ADMIN_ROLE || type === constants.VISIT_ROLE) {
            return (
                <Link to={`machine/${this.props.id}`}>
                    {cont}
                </Link>
            );
        }

        return cont;
    }
}

export default MachineStatusBoxView;



// WEBPACK FOOTER //
// ./src/components/views/MachineStatusBoxView.js